import * as React from "react";
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { fetchOrden } from '../../../actions/ordenesActions';
import { limpiarFiltros } from '../../../actions/generalActios';
import DatosComprador from "../DatosComprador";
import MedioDePago from "../MedioDePago";
import Productos from "../Productos";
import Estados from "../Estados/EstadosOrden";
import Entrega from "../Entrega";
import Comprobantes from "../Comprobantes";
import PubSectionNav from "../../Publicaciones/Components/ABM/PubSectionNav";
import BigSpinner from '../../General/BigSpinner';
import GoBackArrow from "../../General/GoBackArrow";
import PropTypes from "prop-types";
import '../../Publicaciones/Components/PublicacionStyles.css';
import '../OrdenesStyles.css';

const SECTION_GROUPS = [
    { label: "Venta", match: /comprador|producto/i },
    { label: "Logística y pago", match: /entrega|medio/i },
    { label: "Seguimiento", match: /estado|comprobante/i },
];

// Wrapper para usar hooks en class component
function OrdenViewWrapper(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    return <OrdenEdit {...props} navigate={navigate} id={id} location={location} />;
}

class OrdenEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            tabs: [
                { name: "Datos comprador", icon: "ti-user", content: <DatosComprador idOrden={this.props.id} ordenVerde={true} newOrden={false} /> },
                { name: "Productos", icon: "ti-package", content: <Productos newOrden={false} ordenVerde={true} /> },
                { name: "Entrega", icon: "sl-icon-globe", content: <Entrega newOrden={false} ordenVerde={true} /> },
                { name: "Medio de pago", icon: "sl-icon-wallet", content: <MedioDePago newOrden={false} ordenVerde={true} /> },
                { name: "Estados", icon: "sl-icon-layers", content: <Estados history={this.props.history} newOrden={false} ordenVerde={true} /> },
                { name: "Comprobantes", icon: "sl-icon-docs", content: <Comprobantes /> }
            ]
        }
    }

    componentDidMount() {
        this.props.fetchOrden(this.props.id, this.props.userId);
    }

    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }

    return = () => {

        if (!this.props.emptyFiltro.ordenes) {
            this.props.limpiarFiltros({
                publicaciones: true,
                ordenes: false,
                sellers: true,
                showFiltro: false,
                showFiltroOrdenes: true
            })
        }

        const pathReturn = this.props.location.state;
        this.props.navigate(`${pathReturn}`);
    }


    render() {

        const { tabs, activeTab } = this.state;
        const numeroOrden = this.props.id;
        const orden = JSON.stringify(this.props.orden);
        const hasOrden = orden != undefined && orden != "{}";
        const idVendedorBoca = hasOrden ? this.props.orden.idVendedorBoca : null;
        const esAdminMod = this.props.tipoUsuario === 2;

        const switchLogo = (plataformaCodigo) => {

            switch (plataformaCodigo) {
                case 0:
                    return '/img/icono-megatone.png'
                case 1:
                    return '/img/icono-mega-Market.png'
                case 2:
                    return '/img/icono-megatone-express.png'
                default:
                    return ""
            }
        }

        const imgLogo = hasOrden
            ? (this.props.orden.seller.urlLogo || process.env.PUBLIC_URL + switchLogo(this.props.orden.plataforma.codigo))
            : null;

        return (
            <div className="container py-2">
                {this.props.loadingOrdenes ? (
                    <div className="card pub-editor border-0 admin-form-loading d-flex align-items-center justify-content-center py-5">
                        <BigSpinner message="Cargando detalle de la orden..." />
                    </div>
                ) : (
                    <div className="card pub-editor ord-editor border-0">
                        <header className="pub-editor__header">
                            <GoBackArrow />
                            <div className="min-w-0">
                                <p className="pub-editor__kicker">Detalle de orden</p>
                                <h4 className="pub-editor__title text-truncate">Orden {numeroOrden}</h4>
                                <div className="pub-editor__meta">
                                    <span className="pub-editor__id">#{numeroOrden}</span>
                                </div>
                            </div>
                            {esAdminMod && hasOrden &&
                                <div className="ord-editor__brand">
                                    {imgLogo && <img className="orden-detail-logo" alt="icon_mega" src={imgLogo} />}
                                    {idVendedorBoca != 0 && idVendedorBoca &&
                                        <span className="orden-detail-seller-id">{idVendedorBoca}</span>
                                    }
                                </div>
                            }
                        </header>

                        <div className="pub-editor__body">
                            <div className="pub-editor__workspace">
                                <PubSectionNav
                                    tabs={tabs}
                                    activeTab={activeTab}
                                    onChange={this.onChangeActiveTab}
                                    groups={SECTION_GROUPS}
                                    ariaLabel="Secciones de la orden"
                                />
                                <form className="pub-editor__form" onSubmit={this.onSubmit}>
                                    <div className="tab-content">
                                        {tabs[activeTab].content}

                                        <div className="pub-editor__actions">
                                            <button
                                                type="button"
                                                onClick={this.return}
                                                className="btn btn-sm btn-light"
                                            >
                                                Volver
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
OrdenEdit.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        state: PropTypes.string,
    }),
    navigate: PropTypes.func,
    // Redux props
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    history: PropTypes.object,
    emptyFiltro: PropTypes.object,
    orden: PropTypes.shape({
        idVendedorBoca: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        seller: PropTypes.shape({
            urlLogo: PropTypes.string,
        }),
        plataforma: PropTypes.shape({
            codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
    loadingOrdenes: PropTypes.bool,
    tipoUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // Actions props
    fetchOrden: PropTypes.func,
    limpiarFiltros: PropTypes.func,
}

const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    orden: state.ordenes.orden,
    emptyFiltro: state.general.limpiar,
    userId: state.general.userId
});

export default connect(mapStateToProps, {
    fetchOrden,
    limpiarFiltros
})(OrdenViewWrapper);